<div class="grid h-full grid-rows-[auto_1fr] overflow-hidden pt-3">
  <div
    cdkDropList
    class="overflow-y-auto"
    data-testid="checkpoint-list"
    [cdkDropListDisabled]="readonly()"
    (cdkDropListDropped)="onDrop($event)"
  >
    @for (item of items(); track item.id) {
    <div
      cdkDrag
      class="group grid cursor-default grid-cols-[auto_auto_30px_1fr_auto_auto] items-center gap-3 border-b px-4 py-2"
      [attr.data-testid]="'checkpoint-' + item.id"
    >
      <span cdkDragHandle class="flex h-5 w-5 cursor-grab items-center justify-center">
        @if (!readonly()) {
        <soft-ds-icon name="fa-solid fa-grip-vertical" />
        }
      </span>

      <button
        type="button"
        class="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border"
        [disabled]="readonly()"
        [attr.aria-pressed]="isDone(item)"
        [attr.aria-label]="item.title"
        data-testid="checkpoint-toggle"
        (click)="toggle.emit(item)"
      >
        @if (isDone(item)) {
        <soft-ds-icon name="fa-regular fa-check" />
        }
      </button>

      <span class="ds-caption">{{ item.position }}</span>

      <div class="flex flex-col">
        @if (!isDone(item) && !readonly()) {
        <input
          #titleInput
          class="ds-body-1 bg-transparent py-0.5 outline-none"
          [value]="titleOf(item)"
          data-testid="checkpoint-title"
          (keydown.enter)="descriptionInput.focus()"
          (input)="onInput(item, titleInput.value, descriptionInput.value)"
        />
        <input
          #descriptionInput
          class="ds-body-2 bg-transparent py-0.5 outline-none"
          placeholder="Beschreibung hinzufügen..."
          [value]="descriptionOf(item)"
          data-testid="checkpoint-description"
          (input)="onInput(item, titleInput.value, descriptionInput.value)"
        />
        } @else {
        <span class="ds-body-1" [class.line-through]="isDone(item)">
          {{ item.title }}
        </span>
        <span class="ds-body-2" [class.line-through]="isDone(item)">
          {{ item.description }}
        </span>
        }
      </div>

      <span class="ds-caption whitespace-nowrap text-right">
        {{ item.lastStatusChange | date: 'dd.MM.yyyy HH:mm' }}
      </span>

      @if (!readonly()) {
      <button
        type="button"
        class="ml-2 opacity-0 group-hover:opacity-100 focus:opacity-100"
        aria-label="Checkpoint löschen"
        data-testid="checkpoint-delete"
        (click)="remove.emit(item)"
      >
        <soft-ds-icon name="fa-regular fa-xmark" />
      </button>
      }
    </div>
    }
  </div>

  @if (!readonly()) {
  <button
    type="button"
    class="ds-body-2 flex max-h-[61px] items-center gap-3 px-4 py-3"
    data-testid="checkpoint-add"
    (click)="add.emit()"
  >
    <span class="w-5"></span>
    <span
      class="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-dashed"
    >
      <soft-ds-icon name="fa-solid fa-plus" />
    </span>
    Neuen Checkpoint erstellen
  </button>
  }
</div>
